import angular from 'angular'
import routers from './routers'
import addOperatorDialogCtrl from './addOperatorDialogCtrl'
import addReceiverDialogCtrl from './addReceiverDialogCtrl'

import readConfirmCtrl from './readConfirmCtrl'
import { application } from 'redevConfig'

const list = (application && application.list) || ''
const add = (application && application.add) || ''


const applicationListCtrl = list ? require(`redevelopment/outputManage/application/${list.controllerName}`) : require('./applicationListCtrl')
const applicationAddCtrl = add ? require(`redevelopment/outputManage/application/${add.controllerName}`) : require('./applicationAddCtrl')


export default angular
    .module('outputManage.stock.application', [])
    .config(['$stateProvider', ($stateProvider) => {
        Object.keys(routers).forEach((router) => {
            $stateProvider.state(routers[router].state, routers[router].config)
        })
    }])
    .controller('applicationListCtrl', applicationListCtrl.default)
    .controller('addOperatorDialogCtrl', addOperatorDialogCtrl)
    .controller('applicationAddCtrl', applicationAddCtrl.default)
    .controller('addReceiverDialogCtrl', addReceiverDialogCtrl)
    .controller('readConfirmCtrl', readConfirmCtrl)
    .name



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/application/index.js